import React from "react";
import { useTranslation } from "react-i18next";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import TBCBTournamentSubtabsContent from "./TBCBTournamentSubtabsContent";
import TournamentSectionalTabs from "src/components/SectionalTabs/TournamentSectionalTabs";
import { useHomepage } from "src/context/homepage/homepage.provider";

/**
 * Reusable How It Works Section for TBCB promotional pages
 * 
 * @param {Object} props
 * @param {string} props.translationKeyPrefix - The translation key prefix (e.g., "tripleBarrelCashBlast2025")
 * @returns {JSX.Element}
 */
const TBCBHowItWorksSection = ({ translationKeyPrefix }) => {
  const { t } = useTranslation();
  const { tournamentsSubtabs } = useHomepage();
  
  const sectionalTabsContent = t(
    `${translationKeyPrefix}.content.sectionalTabsContent`,
    { returnObjects: true }
  );
  
  const dynamicSubTabs = sectionalTabsContent[`subTab${tournamentsSubtabs}`];

  return (
    <container-div>
      <div className="works-container px-3 pb-3 mt-3">
        <SubTitleSection
          as={"h3"}
          subTitle={t(`${translationKeyPrefix}.content.howItWorks.title`)}
          text={t(`${translationKeyPrefix}.content.howItWorks.text`)}
          className="py-0 how-it-works pt-4"
          borderColor="#d59947"
        />
      </div>

      <div className="tabContent my-4 pt-2 pb-4">
        <TournamentSectionalTabs
          subTabs={t("tbcbCommon.sectionalTabs", {
            returnObjects: true,
          })}
        />
        <TBCBTournamentSubtabsContent tournamentContent={dynamicSubTabs} />
      </div>
    </container-div>
  );
};

export default TBCBHowItWorksSection;
